import { Text } from '@chakra-ui/react';
import React, { ReactNode } from 'react';

import styles from './section-name.module.scss';

export const SectionName: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  return <Text className={styles.sectionName}>{children}</Text>;
};
